const $ = require('jquery');
const Flickity = require('flickity-imagesloaded');
const Clipboard = require('clipboard');
const LazyAllTheThings = require('./lazy-all-things.js');
const HeaderScroll = require('./header-scroll');

window.htmx = require('htmx.org/dist/htmx').default;
window.inlineDonation = $(document).find("#js-inline-donation-button").length > 0;
window.Flickity = Flickity;


require('./header-scroll.js');
require('flickity-bg-lazyload');
require('@fancyapps/fancybox');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui-touch-punch');

require('jquery-pjax');
require('jquery-visible');
require('jquery-ui/ui/widgets/autocomplete');
require('nodep-date-input-polyfill');


require('./header-scroll.js');
const attachAddressPicker = require('./nzpost-address');
// require('bootstrap/dist/js/bootstrap.min.js');
// V:\spca.chirag.dev6.innovanet.co.nz\node_modules\nodep-date-input-polyfill\nodep-date-input-polyfill.js
require('jquery-validation');

// require('jquery-ui/ui/widgets/datepicker');
// require('bootstrap/dist/js/bootstrap.min.js');
// require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js');
require('./jquery-date-dropdowns-forked/dist/jquery.date-dropdowns.min.js');

let headerscroll;

// don't depending on the variable as already test in place after the htmx:afterSwap trigger
// if(window.inlineDonation) {
  // console.log(`inlineDonation is ${window.inlineDonation}`);
// }

const changeQueryParam = (key, value) => {
  if (history.pushState) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set(key, value); // setting your param
    const newUrl = url.href;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
};
window.changeQueryParam = changeQueryParam;

function ll() {
  const lazy = new LazyAllTheThings(
    $,
    window,
    ['.lazy-src', '.lazy-style', '.lazy-video'],
  );
  $(window).scroll(() => {
    lazy.update();
  });
  lazy.update();
}

window._ll = ll;

function updateCentre() {
  if (!window._Cookies.get('__centre')) {
    $('.js-centre-view').removeAttr('href');
    $('.js-centre-view-hide').hide();
    $('.js-site-header__remove-pref').hide();

    $('.js-centre-view').attr('title', 'Choose a centre');
    $('.js-centre-view').not('.js-centre-view-hide').html('Choose a centre');
    return;
  }

  $('.js-site-header__remove-pref').show();
  $('.js-centre-selected').val(window._Cookies.get('__centre'));
  $('.js-local-centre-prompt').removeClass('active');

  $('.js-centre-view')
    .prop('href', `/centre/${window._Cookies.get('__centre')}`);
  $('.js-centre-view')
    .attr('title',
      `View ${$('.js-centre-selected option:selected').data('display')}`);
  $('.js-centre-view')
    .not('.js-centre-view-hide')
    .html(`View ${$('.js-centre-selected option:selected').data('display')}`);
  $('.js-centre-view').show();

  if ($('.js-section--newsletter').length) {
    if ($('.js-section--newsletter').find('.validationErrors').length == 0) {
      $('#select-newsletter-nearest-centre')
        .val($('.js-centre-selected option:selected').data('display'));
      $('.js-newsletter-centre')
        .val($('.js-centre-selected option:selected').data('display'));
    }
  }

  if ($('.js-contact-centre').length && $('.js-contact-centre').length > 0) {
    $('.js-contact-centre').val($('.js-centre-selected option:selected').data('display'));
  }
}

window.existingRecaptcha = {};

const recaptchaInit = () => {
  const allRecaptcha = document.querySelectorAll('.recaptcha');
  for (let i = 0, c = allRecaptcha.length; i < c; i += 1) {
    const el = allRecaptcha[i];
    const id = el.getAttribute('id');
    const sitekey = el.getAttribute('sitekey');

    if (existingRecaptcha.hasOwnProperty(id) && el.childNodes.length > 0) {
      grecaptcha.reset(existingRecaptcha[id]);
    } else {
      existingRecaptcha[id] = grecaptcha.render(el, {
        sitekey,
      });
    }
  }
};

const recaptchaLoad = () => {
  // load re-captcha
  const recaptchaScript = document.createElement('script');
  recaptchaScript.async = true;
  recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaInit&render=explicit';
  document.querySelector('head').appendChild(recaptchaScript);
};

window.recaptchaInit = recaptchaInit;

$(document).ready(($) => {
  ll();
  attachAddressPicker($);
  recaptchaLoad();

  // Keep the donation form in view on each HTMX step change.
  const scrollToDonationFormContainer = () => {
    const donationForm = document.querySelector('.donation-widget-container')
      || document.querySelector('#donation-form-container')
      || document.querySelector('.donate-form-area')
      || document.querySelector('#js-inline-donation-button');
    if (!donationForm) {
      return;
    }

    const header = document.querySelector('.js-site-header');
    const headerOffset = window.innerWidth < 1000 && header ? header.clientHeight : 0;
    const formPosition = donationForm.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: Math.max(formPosition - headerOffset, 0),
      behavior: 'smooth',
    });
  };

  // Soften HTMX content replacement so step 2 → 3 does not pop in abruptly.
  const fadeInDonationSwap = (el) => {
    if (!el || !window.inlineDonation) {
      return;
    }

    el.style.opacity = '0';
    el.style.transition = 'opacity 280ms ease';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });
    });
    window.setTimeout(() => {
      el.style.transition = '';
      el.style.opacity = '';
    }, 320);
  };

  // Add HTMX event listener here, after DOM is ready
  document.body.addEventListener('htmx:afterSwap', function(evt) {
    // Check if the swap was for your donation container
    if (evt.target.id === 'js-inline-donation-container') {
      // Clear the require cache for donate.js
      delete require.cache[require.resolve('./donate.js')];
      // Require the script again
      require('./donate.js');
      // Initial inline load only — do not scroll the page on first paint.
      setTimeout(() => {
        $(".js-site-header.header-scroll").removeClass('nav-up nav-down').addClass('nav-up');
      }, 50);
    }
    if (evt.target.id === 'donation-form-container') {
      // Get the iframe props from the data attribute
      const iframeProps = JSON.parse(evt.target.dataset.iframeProps || '{}');
      // Set the iframe props on window
      window.iframeprops = iframeProps;
      
      // Clear the require cache for payment.js
      delete require.cache[require.resolve('./payment.js')];
      // Require the script again
      require('./payment.js');
      recaptchaInit();
      fadeInDonationSwap(evt.target);
      scrollToDonationFormContainer();
      setTimeout(() => {
        $(".js-site-header.header-scroll").removeClass('nav-up nav-down').addClass('nav-up');
      }, 50);
    }
  });

  // for ie9
  if ($('.js-slider-gallery').length && !$('.js-slider-gallery').find('.flickity-viewport').length) {
    $.each($('.js-slider-gallery img'), (idx, itm) => {
      $(itm).attr('src', $(itm).attr('data-flickity-lazyload'));
    });
  }

  // advice autocomplete block
  if ($('.js-advice-autocomplete').length) {
    $('.js-advice-autocomplete').autocomplete({
      source(request, response) {
        $.ajax({
          url: '/advice/autocomplete',
          dataType: 'json',
          data: { term: request.term },
          success(data) {
            response($.map(data, item => ({
              label: item.title,
              value: item.slugfragment,
            })));
          },
        });
      },
      minLength: 3,
      select(event, ui) {
        event.preventDefault();
        const { protocol } = location;
        const slashes = protocol.concat('//');
        const host = slashes.concat(window.location.hostname);
        window.location.href = `${host}/advice-and-welfare/article/${
          ui.item.value}`;
      },
      focus(event, ui) {
        event.preventDefault(); // or return false;
      },
    }).data('ui-autocomplete')._renderItem = function (ul, item) {
      const newText = String(item.label).replace(
        new RegExp(this.term, 'gi'),
        '<span class=\'ui-menu-item__term\'>$&</span>',
      );

      return $('<li></li>')
        .data('item.autocomplete', item)
        .append(`<div>${newText}</div>`)
        .appendTo(ul);
    };
  }


  // advocacy position statemen autocomplete block
  if ($('.js-advocacy-position-statement-autocomplete').length) {
    $('.js-advocacy-position-statement-autocomplete').autocomplete({
      source(request, response) {
        $.ajax({
          url: '/advocacy/position-statements/autocomplete',
          dataType: 'json',
          data: { term: request.term },
          success(data) {
            response($.map(data, item => ({
              label: item.title,
              value: item.slugfragment,
            })));
          },
        });
      },
      minLength: 3,
      select(event, ui) {
        event.preventDefault();
        window.location.href = `/advocacy/position-statements/article/${ui.item.value}?term=${this.value}`;
      },
      focus(event) {
        event.preventDefault(); // or return false;
      },
      classes: {
        'ui-autocomplete': 'advocacy-position-statement-autocomplete',
      },
    }).data('ui-autocomplete')._renderItem = function (ul, item) {
      const newText = String(item.label).replace(
        new RegExp(this.term, 'gi'),
        '<span class=\'ui-menu-item__term\'>$&</span>',
      );

      return $('<li></li>')
        .data('item.autocomplete', item)
        .append(`<div>${newText}</div>`)
        .appendTo(ul);
    };
  }
  window._Cookies = require('js-cookie');

  // attach copy to clipboard...
  const cb = new Clipboard('.js-clipboard-anchor');
  const $note = $('.social-clipboard-note');

  cb.on('success', () => {
    $note.addClass('active');
    setTimeout(() => {
      $note.removeClass('active');
    }, 2000);
  });

  $(document).on('click', '.print-link', () => {
    window.print();
  });

  $(document).on('click', '.js-local-centre-prompt-dismiss', () => {
    window._Cookies.set('__silence', 1, { expires: 7 });
    $('.js-local-centre-prompt').removeClass('active');
  });

  $(document).on('change', '.js-centre-selected', function () {
    window._Cookies.set('__centre', $(this).val(), { expires: 365 });
    updateCentre();
  });

  $(document).on('click', '.js-site-header__remove-pref', () => {
    $('.js-centre-selected').val('');
    window._Cookies.set('__centre', '', { expires: 365 });
    updateCentre();
  });

  if (!window._Cookies.get('__centre')
        && !window._Cookies.get('__silence')
        && $('body').attr('id') != 'page--advocacy-campaign'
        && $('body').attr('id') != 'page--advocacy-campaign-thank-you'
  ) {
    setTimeout(() => {
      $('.js-local-centre-prompt').addClass('active');
    }, 3000);
  }

  updateCentre();

  if ($('.js-section--newsletter').length) {
    if ($('.js-section--newsletter').data('sent')) {
      $('.js-section--newsletter').find(':text').val('');
      $('.js-section--newsletter').find('.js-card-link').click();
    }
    $('.js-newsletter-centre').val($('.js-section--newsletter select').val());
    $(document).on('change', '.js-section--newsletter select', () => {
      $('.js-newsletter-centre').val($('.js-section--newsletter select').val());
    });
  }

  // load GoogleMap
  if ($('#spca-centre-locations').length
        && !$('body').hasClass('template--service-list')
        && !$('body').hasClass('template--centre-detail')) {
    const mapsUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAedo0Ue-eClfghT8QtaWghE7Qxdd_ds0U&callback=initMap';
    const mapsScript = document.createElement('script');
    mapsScript.async = true;
    mapsScript.src = mapsUrl;
    document.querySelector('head').appendChild(mapsScript);
  }

  // attach a header scroll listener
  // not even sure this needs to be a class
  headerscroll = new HeaderScroll($, '.js-site-header');

  // -------------------------------------------------------------------------------------------------------
  // Toggle link
  // -------------------------------------------------------------------------------------------------------
  $(document).on('click', '.js-toggle', function () {
    $(this).toggleClass('active');
    $($.attr(this, 'href')).toggleClass('active');
    // $('.js-adopt-filter-panel').toggleClass('active');
    return false;
  });

  // -------------------------------------------------------------------------------------------------------
  // Close a toggled modal
  // -------------------------------------------------------------------------------------------------------
  $(document).on('click', '.js-modal-close', () => {
    $('.js-toggle-modal').removeClass('active');
    return false;
  });


  // -------------------------------------------------------------------------------------------------------
  // Main nav toggle
  // -------------------------------------------------------------------------------------------------------
  $('.js-mainnav-toggle').on('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    $(this).toggleClass('active');
    $('.js-mainnav').toggleClass('active');
    $('.js-mainnav-overlay').toggleClass('active');
    $('.js-body').toggleClass('mainnav-active');
  });
  $('.js-mainnav-overlay').on('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    $(this).removeClass('active');
    $('.js-mainnav').removeClass('active');
    $('.js-mainnav-toggle').removeClass('active');
  });


  // -------------------------------------------------------------------------------------------------------
  // On scroll
  // -------------------------------------------------------------------------------------------------------
  $(window).scroll(function () {
    if ($(this).scrollTop() > 10) {
      $('.js-body').addClass('scrolling');
    } else {
      $('.js-body').removeClass('scrolling');
    }
  });


  // -------------------------------------------------------------------------------------------------------
  // Main nav - level 2 toggle
  // -------------------------------------------------------------------------------------------------------
  $(document).on('click', '.js-mainnav-level2-toggle', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    const $this = $(this);
    const $nav = $this.parent().find('.dropdown-nav--mainnav');
    $this.toggleClass('active');
    $('.dropdown-nav--mainnav').not($nav).removeClass('active');
    $nav.toggleClass('active');
  });


  // -------------------------------------------------------------------------------------------------------
  // Site search
  // -------------------------------------------------------------------------------------------------------
  $('.js-button-site-search').click(() => {
    $('.js-search-form-panel').addClass('active');
    $('.js-search-field').focus();
    return false;
  });
  $('.js-search-form-panel').click(function () {
    $(this).removeClass('active');
    return false;
  }).on('click', '.js-search-form-fields', (e) => {
    e.stopPropagation();
  });
  $(document).on('keydown', (e) => {
    if (e.keyCode === 27) { // ESC
      $('.js-search-form-panel').removeClass('active');
    }
  });


  // -------------------------------------------------------------------------------------------------------
  // Local centre prompt
  // -------------------------------------------------------------------------------------------------------
  $(document).on('click', '.js-local-centre-prompt-dismiss', () => {
    $('.js-local-centre-prompt').removeClass('active');
    return false;
  });

  $('.js-fancybox').fancybox({
    afterShow() {
      // $( ".js-datepicker" ).datepicker( "refresh" );
    },
  });


  // -------------------------------------------------------------------------------------------------------
  // date picker dropdown
  // -------------------------------------------------------------------------------------------------------
  function refreshDatePicker() {
    // if($(window).width()>1023) {
    $('.js-datepicker').dateDropdowns({
      wrapperClass: 'field--dropdown field--date-dropdown js-field--date-dropdown',
      daySuffixes: false,
    });
  
    setTimeout(() => {
      $('.js-field--date-dropdown').find('.day').wrap("<div class='select'></div>");
      $('.js-field--date-dropdown').find('.day > option:first-child').text('Day:');
      $('.js-field--date-dropdown').find('.month').wrap("<div class='select'></div>");
      $('.js-field--date-dropdown').find('.month > option:first-child').text('Month:');
      $('.js-field--date-dropdown').find('.year').wrap("<div class='select'></div>");
      $('.js-field--date-dropdown').find('.year > option:first-child').text('Year:');
    }, 1000);
  
    $('.js-datepicker').parents("li").find('.js-icon--datepicker').addClass('visuallyhidden');
    // }
  }
  
  window.refreshDatePicker = refreshDatePicker;
  refreshDatePicker();


  // -------------------------------------------------------------------------------------------------------
  // bootstrap date picker
  // -------------------------------------------------------------------------------------------------------

  // function refreshDatePicker() {
  //     $(document).find('.js-datepicker').each(function(){
  //         if($(window).width() > 700) {
  //             $(this).datepicker({
  //                 autoclose: true,
  //                 clearBtn: true,
  //                 format: "yyyy-mm-dd",
  //                 container: $(this).parent("li")
  //             });
  //         } else {
  //             $(this).prop('type', 'date');
  //         }
  //     });
  // }
  // refreshDatePicker();


  // -------------------------------------------------------------------------------------------------------
  // Global accordions
  // -------------------------------------------------------------------------------------------------------
  const allPanels = $('.js-accordion-content')
    .not('.js-loaded')
    .removeClass('active');

  $(document).on('click', '.js-accordion-heading', function (ev) {
    
    // page--report-animal-cruelty
    $('.js-accordion-content').removeClass('active');
    ev.preventDefault();
    ev.stopPropagation();

    const $this = $(this);
    allPanels.removeClass('active');
    $('.js-accordion-heading').not(this).removeClass('active');
    $this.toggleClass('active');
    if ($this.hasClass('active')) {
      $this.parent().find('.js-accordion-content').addClass('active');
    }

    setTimeout(() => {
      // scroll to clicked accordion on one page only
      if($(".js-body").attr("id") == "page--report-animal-cruelty") {
        // keep the sticky nav in the same position
        const navStatus = $(document).find(".js-site-header.header-scroll").hasClass('nav-up') ? 'nav-up' : 'nav-down';
        let extraHeight = navStatus == "nav-up" ? 0 : $(document).find(".js-site-header.header-scroll").outerHeight();
        if ($(window).width() < 1280) {
          extraHeight = $(document).find(".js-site-header").outerHeight();
        }
        const thisVar = $(this);

        $('html, body').animate({
          scrollTop: thisVar.offset().top - extraHeight
        }, 0);
        $(".js-site-header.header-scroll").removeClass('nav-up nav-down').addClass(navStatus);
        setTimeout(function() {
          $(".js-site-header.header-scroll").removeClass('nav-up nav-down').addClass(navStatus);
        }, 500);

      }
    }, 200);

  });
  // $('.js-accordion-heading').first().addClass('active');
  // $('.js-accordion-heading').first().parent().find('.js-accordion-content').addClass('active');


  // -------------------------------------------------------------------------------------------------------
  // Global accordions
  // -------------------------------------------------------------------------------------------------------
  function openTestimonialModal(url) {
    $('#modal-testimonial').html('<div class="modal-info modal-inner"><div class="loading-spinner-wrap active"><div class="loading-spinner loading-spinner"></div></div></div>');

    $.pjax.reload('#modal-testimonial', {
      url,
      fragment: '#modal-testimonial',
    });

    $.fancybox.open([{
      type: 'inline',
      src: '#modal-testimonial',
    }], {
      padding: 0,
      smallBtn: false,
      touch: false,
      afterShow() {
        $('.fancybox-toolbar').addClass('compensate-for-scrollbar');
      },
      afterClose() {
        $('.js-pjax-container').removeClass('content-loading');
      },
    });
  }

  // Testimonial slider block - Open modal
  $(document).on('click', '.js-testimonial-modal-cta', function () {
    openTestimonialModal($(this).data('url'));
  });

  if (window.location.search.indexOf('?testimonial') >= 0) {
    $.fancybox.open([{
      type: 'inline',
      src: '#modal-testimonial',
    }], {
      padding: 0,
      smallBtn: false,
      touch: false,
      afterShow() {
        $('.fancybox-toolbar').addClass('compensate-for-scrollbar');
      },
      afterClose() {
        $('.js-pjax-container').removeClass('content-loading');
      },
    });
  }

  /*
     By Osvaldas Valutis, www.osvaldas.info
     Available for use under the MIT License
     */
  $('[type=file]').each(function () {
    const $input = $(this);
    const $label = $input.prev('label');
    const labelVal = $label.html();

    $input.on('change', function (e) {
      let fileName = '';

      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace(
          '{count}', this.files.length,
        );
      } else if (e.target.value) {
        fileName = e.target.value.split('\\').pop();
      }
      if (fileName) {
        $label.html(fileName);
      } else {
        $label.html(labelVal);
      }
    });

    // Firefox bug fix
    $input.on('focus', () => {
      $input.addClass('has-focus');
    }).on('blur', () => {
      $input.removeClass('has-focus');
    });
  });

  // generic PJAX anchor
  if ($.support.pjax) {
    $.pjax.defaults.timeout = 3000;

    $(document).on('click', '.js-pjax-anchor', function (event) {
      $('.js-pjax-anchor').removeClass('active');
      $(this).addClass('active');
      $.pjax.click(event, {
        scrollTo: false,
        container: '.js-pjax-container',
        fragment: '.js-pjax-container',
      });
    });

    $(document).on('click', '.js-pjax-anchor-li', function (event) {
      $('.js-pjax-anchor-li').parent('li').removeClass('active');
      $(this).parent('li').addClass('active');
      $.pjax.click(event, {
        scrollTo: false,
        container: '.js-pjax-container',
        fragment: '.js-pjax-container',
      });
    });


    $('.js-pjax-container').on('pjax:send', (xhr, options, event) => {
      $('.js-pjax-container').addClass('content-loading');
      $('.js-pjax-container-loading').show();
    });

    // reload Flickity on pjax complete
    $('.js-pjax-container').on('pjax:complete', () => {
      if ($(document).find('.js-slider-gallery').length > 0) {
        // var flkty = $$(document).find('.js-slider-gallery').flickity();
        // flkty.flickity('resize');
        const flkty = new Flickity('.js-slider-gallery', {
          contain: true,
          imagesLoaded: true,
        });

        if ($('.js-caption').length > 0) {
          flkty.on('change', (index) => {
            $('.js-caption').html($(flkty.selectedElement).find('img').attr('alt'));
          });
        }
      }
      $('.js-pjax-container').removeClass('content-loading');
      $('.js-pjax-container-loading').hide();
      recaptchaInit();
    });

    $(document).on('submit', '.js-pjax-submit-form', (event) => {
      $.pjax.submit(event, {
        scrollTo: false,
        container: '.js-pjax-form-container',
        fragment: '.js-pjax-form-container',
      });
    });

    $('.js-pjax-form-container').on('pjax:complete', () => {
      initBequestRegistrationForm();
    });


    $(document).on('submit', '.js-pjax-contact-form', (event) => {
      $.pjax.submit(event, {
        scrollTo: false,
        container: '.js-pjax-contact-form-container',
        fragment: '.js-pjax-contact-form-container',
      });
    });

    $('.js-pjax-contact-form-container').on('pjax:start', () => {
      $('.js-contact-form-submit-button').attr('disabled', true);
      $('.js-contact-form-submit-button').val('Sending...');
    });

    $('.js-pjax-contact-form-container').on('pjax:complete', () => {
      $('.js-contact-form-submit-button').attr('disabled', false);
    });

    $(document).on('submit', '.js-modal-form', function (event) {
      // dont change this variable ie needs it this way
      const serializedArray = $(this).serialize();
      const thisObj = $(this);
      event.preventDefault();

      const container = $(this).closest('.js-modal-form-container');
      $(container).find('div').first().html($('.js-modal-form-spinner').html());

      const elemSelector = container.attr('id')
        ? `#${container.attr('id')}`
        : '.js-modal-form-container';


      // ------------------------------------------------------------------
      // fix by Ricky which took me long long time to debug...
      // ------------------------------------------------------------------

      // ------------------------------------------------------------------
      // fix by Weida - wtf Ricky took me long long time to debug too
      // ------------------------------------------------------------------
      let formdata = false;
      if (window.FormData) {
        formdata = new FormData();
      }

      $(this).find('input, textarea,select').not('input[type=file]').each(function () {
        if (this.type == 'radio' && $(this).prop('checked') == true) {
          formdata.append(this.name, this.value);
        } else if (this.type == 'checkbox' && $(this).prop('checked') == true) {
          formdata.append(this.name, this.value);
        } else if (this.type == 'select' && $(this).children('option:selected').val()) {
          formdata.append(this.name, this.value);
        } else if (this.type != 'radio' && this.type != 'select' && this.type != 'checkbox') {
          formdata.append(this.name, this.value);
        }
      });


      const file = $(this).find('input[type=file]');
      if (file.length > 0 && typeof file[0].files !== 'undefined') {
        // console.log('file',file);
        // console.log('file.name',file.attr('name'));

        const fileData = file[0].files[0];

        // console.log(fileData.type);
        // Only process image files.
        if (typeof fileData !== 'undefined' && fileData.type.match('image.*')) {
          // Appends the currently selected File of an <input type="file" id="file"> element the FormData instance
          // which is later to be sent as multipart/form-data XHR request body
          // console.log("fileData", fileData);

          formdata.append(file.attr('name'), fileData);
        }
      }

      $.ajax({
        type: 'POST',
        url: $(this).attr('action'),
        processData: false, // tell jQuery not to process the data
        contentType: false,
        beforeSend() {
          $(container).find('div').first().html($('.js-modal-form-spinner').html());
        },
        data: formdata, // serializes the form's elements.
        cache: false, // trying this because of ie
        success(data) {
          const $response = $(data);
          const dataToday = $response.find(elemSelector).html();
          $(elemSelector).html(dataToday);
          recaptchaInit();
          refreshDatePicker();

          jsValidationFormValidate();

          // ------------------------------------------------------------------
          // Comment by Chirag - It is not the part which took long long time for Ricky and Weida to debug, it just change the query param on success of form
          // ------------------------------------------------------------------
          if (thisObj.data('addqureyparam') == 'yes' && $response.find('#js-volunteer-form-thanks').length !== 0) {
            changeQueryParam('application', 'finish');
          }
        },
      });

      jsValidationFormValidate();


      event.preventDefault();

      //
      // $.pjax.submit(event, elemSelector, {
      //     fragment: elemSelector,
      // });
    });
  }


  /**
     * Bequest form logic
     */
  if ($('.js-bequest-block').length) {
    updateBequestForm();
    $('.js-bequest-loading').hide();
    $('.js-bequest-container').show();

    $(document).on('change', '.js-contact-type input[type=radio]', () => {
      updateBequestForm();
    });
    /**
         * Bequest form logic ends
         */
  }

  jsValidationFormValidate();


  initServiceRegistrationForm();
  initBequestRegistrationForm();
  initVideoModal();

  // Initialize HTMX on document ready
  if (window.htmx) {
    window.htmx.process(document.body);
  }
});

function initServiceRegistrationForm() {
  const serviceRegistrationFormTarget = document.getElementById('service-registration-form_target');
  if (serviceRegistrationFormTarget) {
    const redirect = serviceRegistrationFormTarget.value;
    window.history.pushState(null, null, redirect);
  }
}

function initBequestRegistrationForm() {
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.get('submitted') === true || queryParams.get('submitted') == 'true') {
    queryParams.set('submitted', 'false');
    window.history.pushState(null, null, `?${queryParams.toString()}`);
  } else {
    const serviceRegistrationFormTarget = document.getElementById('bequest-registration-form_target');

    if (serviceRegistrationFormTarget) {
      const redirect = serviceRegistrationFormTarget.value;
      window.history.pushState(null, null, redirect);
    }
  }
}

function initVideoModal() {
  const urlParams = new URLSearchParams(window.location.search);
  const videoId = urlParams.get('video');
  if (videoId) {
    $(`#video-${videoId}`).fancybox();
    $(`#video-${videoId}`).trigger('click');
  }
}

function jsValidationFormValidate() {
  $(document).on('keyup', '.js-mobile', function (e) {
    const value = $(this).val();
    const intRegex = /^(((\+64|64)|0)2[0-9]{1})[\s|-]{0,1}(([0-9]{6,8})|(([0-9]{3,5}[\s|-][0-9]{3})|([0-9]{3}[\s|-][0-9]{3,5})|([0-9]{3,4}[\s|-][0-9]{3,4})))$/;
    if (value) {
      if (!isNaN(value) && value.slice(0, 1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) {
        $(this).parent('li').find('.js-validationErrors').remove();
        $(this).parent('li').find('.validationErrors').remove();
      } else if ($(this).parent('li').find('.validationErrors').length == 0 && $(this).parent('li').find('.js-validationErrors').length == 0) {
        $(this).parent('li').append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).</span></div>');
      }
    }
  });

  $(document).on('keyup', '.js-just-mobile-validation', function (e) {
    const value = $(this).val();
    const intRegex = /^(((\+64|64)|0)2[0-9]{1})[\s|-]{0,1}(([0-9]{6,8})|(([0-9]{3,5}[\s|-][0-9]{3})|([0-9]{3}[\s|-][0-9]{3,5})|([0-9]{3,4}[\s|-][0-9]{3,4})))$/;
    if (value) {
      if (!isNaN(value) && (value === null || value == '') || (value.slice(0, 1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0)) {
        $(this).parent('li').find('.js-validationErrors').remove();
        $(this).parent('li').find('.validationErrors').remove();
      } else if ($(this).parent('li').find('.validationErrors').length == 0 && $(this).parent('li').find('.js-validationErrors').length == 0) {
        $(this).parent('li').append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).</span></div>');
      }
    }
  });

  $(document).on('keyup', '.js-phoneormobile', function (e) {
    const value = $(this).val();
    const intRegex = /[0-9 -()+]+$/;
    if (value) {
      if (!isNaN(value) && (value === null || value == '') || (value.slice(0, 1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0)) {
        $(this).parent('li').find('.js-validationErrors').remove();
        $(this).parent('li').find('.validationErrors').remove();
      } else if ($(this).parent('li').find('.validationErrors').length == 0 && $(this).parent('li').find('.js-validationErrors').length == 0) {
        $(this).parent('li').append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include the area code or mobile prefix and ensure the number has no spaces (e.g. 041234567 or 0211234567).</span></div>');
      }
    }
  });

  $(document).on('keyup', '.js-phone', function (e) {
    const value = $(this).val();
    const intRegex = /[0-9 -()+]+$/;
    if (value) {
      if (!isNaN(value) && (value.slice(0, 1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) || value.length == 0) {
        $(this).parent('li').find('.js-validationErrors').remove();
        $(this).parent('li').find('.validationErrors').remove();
      } else if ($(this).parent('li').find('.validationErrors').length == 0 && $(this).parent('li').find('.js-validationErrors').length == 0) {
        $(this).parent('li').append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include your area code and ensure the number has no spaces (e.g. 041234567).</span></div>');
      }
    }
  });

  $(document).on('keyup', '.js-email', function (e) {
    const value = $(this).val();
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (value) {
      if (re.test(String(value).toLowerCase())) {
        $(this).parent('li').find('.js-validationErrors').remove();
        $(this).parent('li').find('.validationErrors').remove();
      } else if ($(this).parent('li').find('.validationErrors').length == 0 && $(this).parent('li').find('.js-validationErrors').length == 0) {
        $(this).parent('li').append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">This value is not a valid email address.</span></div>');
      }
    }
  });


  // $.validator.addClassRules('js-mobile', {
  //     mobileRule: true
  // });

  // $('.js-validation-form').each( function(){
  //     var form = $(this);
  //     form.validate({
  //         wrapper: "div",
  //         errorClass: 'jquery-error',
  //         errorElement : 'span'
  //     });
  // });


  // /**
  //  * Mobile number validation
  //  */
  //
  // $.validator.addMethod('mobileRule', function(value, element, params) {
  //     if(!value) {
  //         return true;
  //     }
  //     var intRegex = /[0-9 -()+]+$/;
  //     if(!isNaN(value) && value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) {
  //         return true;
  //     }
  //     return false;
  // }, "Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).");

  // /**
  //  * Just mobile number validation not required
  //  */
  //
  // $.validator.addMethod('justMobileRule', function(value, element, params) {
  //     if(!value) {
  //         return true;
  //     }
  //     var intRegex = /[0-9 -()+]+$/;
  //     if(!isNaN(value) && (value === null || value == '') || (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0)) {
  //         return true;
  //     }
  //     return false;
  // }, "Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).");
  //
  // /**
  //  * Landline number validation and landlord's phone number field
  //  */
  // $.validator.addMethod('phoneOrMobileRule', function(value, element, params) {
  //     if(!value) {
  //         return true;
  //     }
  //     var intRegex = /[0-9 -()+]+$/;
  //     if(!isNaN(value) && (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) || value.length == 0) {
  //         return true;
  //     }
  //     return false;
  // }, "Please include the area code or mobile prefix and ensure the number has no spaces (e.g. 041234567 or 0211234567).");
  //
  // /**
  //  * emergency contact field and
  //  */
  // $.validator.addMethod('phoneRule', function(value, element, params) {
  //     if(!value) {
  //         return true;
  //     }
  //     var intRegex = /[0-9 -()+]+$/;
  //     if(!isNaN(value) && (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) || value.length == 0) {
  //         return true;
  //     }
  //     return false;
  // }, "Please include your area code and ensure the number has no spaces (e.g. 041234567).");
  //
  //
  // $( ".js-validation-form input:text, .js-validation-form input:checkbox, .js-validation-form input:radio, .js-validation-form select, .js-validation-form textarea" ).each(function( index ) {
  //     $(this).rules('remove', 'required');
  //     $(this).attr("required", false);
  // });
  //
  // $.validator.addClassRules('js-mobile', {
  //     mobileRule: true
  // });
  //
  // $.validator.addClassRules('js-just-mobile-validation', {
  //     justMobileRule: true
  // });
  //
  // $.validator.addClassRules('js-phoneormobile', {
  //     phoneOrMobileRule: true
  // });
  //
  // $.validator.addClassRules('js-phone', {
  //     phoneRule: true
  // });
  //
  // $.validator.addClassRules('js-email', {
  //     email: true
  // });
}
window.jsValidationFormValidate = jsValidationFormValidate;
function disableBequestFormFields() {
  $('.js-input-specific-fields').hide();
  $('.js-input-specific-fields input').prop('disabled', true);
}

function updateBequestForm() {
  disableBequestFormFields();
  if ($('.js-contact-type').find('input:checked').val() == 'By email') {
    disableBequestFormFields();
    $('.js-show-only-for-email').show();
    $('.js-show-only-for-email input').prop('disabled', false);
  } else if ($('.js-contact-type').find('input:checked').val() == 'By phone') {
    disableBequestFormFields();
    $('.js-show-only-for-phone').show();
    $('.js-show-only-for-phone input').prop('disabled', false);
  } else if ($('.js-contact-type').find('input:checked').val()
        == 'Please send me a brochure') {
    disableBequestFormFields();
    $('.js-show-only-for-brochure').show();
    $('.js-show-only-for-brochure input').prop('disabled', false);
  }
}

function initMapDesktop(map) {
  const infoWindows = [];
  const markers = [];
  const resetMarkers = function () {
    for (var idx in markers) {
      var itm = markers[idx];
      itm.setIcon({
        url: '/images/map-marker@2x.png',
        scaledSize: new google.maps.Size(23, 28),
      });
      itm.setAnimation(null);
    }

    for (var idx in infoWindows) {
      var itm = infoWindows[idx];
      itm.close();
    }
  };
  const SnazzyInfoWindow = require('snazzy-info-window');
  $.each($('.js-map-item'), (idx, itm) => {
    const mapMarker = new google.maps.Marker({
      position: {
        lat: parseFloat($(itm).data('lat'), 10),
        lng: parseFloat($(itm).data('lng'), 10),
      },
      map,
      icon: {
        url: '/images/map-marker@2x.png',
        scaledSize: new google.maps.Size(23, 28),
      },
      idx,
    });
    mapMarker.addListener('click', function () {
      location.href = $(`.js-map-item-${this.idx}`).attr('href');
    });
    mapMarker.addListener('mouseover', function () {
      resetMarkers();
      markers[this.idx].setIcon({
        url: '/images/map-marker--selected.png',
        scaledSize: new google.maps.Size(23, 28),
      });
      infoWindows[this.idx].open();
    });
    mapMarker.addListener('mouseout', () => {
      // resetMarkers();
    });

    let content = '<div class="location-map-tooltip">';
    if ($('body').attr('id') == 'page--report-animal-cruelty') {
      content += `<a class="h3 location-map-tooltip-heading" href="#${
        $(itm).data('slug')}"><span class="button-txt">${$(itm).html()
      }</span></a>`;
      content += $(itm).data('cruelty')
        ? `<div class="location-map-tooltip__info location-map-tooltip__info--cruelty"><i class="icon"></i>${
          $(itm).data('cruelty')}</div>`
        : '';
      content += `<div class="location-map-tooltip__info location-map-tooltip__info--address"><i class="icon"></i>${
        $(itm).data('address')}</div>`;
    } else {
      content += `<a class="h3 location-map-tooltip-heading" href="#${
        $(itm).data('slug')}"><span class="button-txt">${$(itm).html()
      }</span></a>`;
      content += `<div class="location-map-tooltip__info location-map-tooltip__info--ph"><i class="icon"></i>${
        $(itm).data('phone')}</div>`;
      content += `<div class="location-map-tooltip__info location-map-tooltip__info--address"><i class="icon"></i>${
        $(itm).data('address')}</div>`;
    }
    content += '</div>';

    const infoWindow = new SnazzyInfoWindow({
      marker: mapMarker,
      content,
      placement: 'right',
      offset: {
        top: '-20px',
        left: '40px',
      },
    });
    markers.push(mapMarker);
    infoWindows.push(infoWindow);

    $(itm).on('mouseenter', function () {
      resetMarkers();
      const idx = $(this).data('idx');
      markers[idx].setIcon({
        url: '/images/map-marker--selected.png',
        scaledSize: new google.maps.Size(23, 28),
      });
      markers[idx].setAnimation(google.maps.Animation.BOUNCE);
    });

    $(itm).on('mouseleave', () => {
      resetMarkers();
    });
  });
}

const mobileAndTabletcheck = () => {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  }(navigator.userAgent || navigator.vendor || window.opera));
  return check;
};
window.mobileAndTabletcheck = mobileAndTabletcheck;


function initMapMobile(map) {
  const infoWindows = [];
  const markers = [];
  const resetMarkers = function () {
    for (var idx in markers) {
      var itm = markers[idx];
      itm.setIcon({
        url: '/images/map-marker@2x.png',
        scaledSize: new google.maps.Size(23, 28),
      });
      itm.setAnimation(null);
    }

    for (var idx in infoWindows) {
      var itm = infoWindows[idx];
      itm.close();
    }
  };
  const SnazzyInfoWindow = require('snazzy-info-window'); map.setZoom;
  $.each($('.js-map-item'), (idx, itm) => {
    const mapMarker = new google.maps.Marker({
      position: {
        lat: parseFloat($(itm).data('lat'), 10),
        lng: parseFloat($(itm).data('lng'), 10),
      },
      map,
      icon: {
        url: '/images/map-marker@2x.png',
        scaledSize: new google.maps.Size(23, 28),
      },
      idx,
    });
    mapMarker.addListener('click', function () {
      resetMarkers();
      markers[this.idx].setIcon({
        url: '/images/map-marker--selected.png',
        scaledSize: new google.maps.Size(23, 28),
      });
      infoWindows[this.idx].open();
    });

    let content = '<div class="location-map-tooltip">';
    content += `<a class="h3 location-map-tooltip-heading" href="/centre/${
      $(itm).data('slug')}"><span class="button-txt">${$(itm).html()
    }</span><i class="icon "></i></a>`;
    content += `<div class="location-map-tooltip__info location-map-tooltip__info--ph"><i class="icon"></i>${
      $(itm).data('phone')}</div>`;
    content += `<div class="location-map-tooltip__info location-map-tooltip__info--address"><i class="icon"></i>${
      $(itm).data('address')}</div>`;
    content += '</div>';

    const infoWindow = new SnazzyInfoWindow({
      marker: mapMarker,
      content,
      placement: 'right',
      offset: {
        top: '-20px',
        left: '40px',
      },
    });
    markers.push(mapMarker);
    infoWindows.push(infoWindow);

    $(itm).on('mouseenter', function () {
      resetMarkers();
      const idx = $(this).data('idx');
      markers[idx].setIcon({
        url: '/images/map-marker--selected.png',
        scaledSize: new google.maps.Size(23, 28),
      });
      markers[idx].setAnimation(google.maps.Animation.BOUNCE);
    });

    $(itm).on('mouseleave', () => {
      resetMarkers();
    });
  });
}


function initMap() {
  const nz = {
    lat: -40.785071,
    lng: 172.405249,
  };

  if (!document.getElementById('centre-map')) {
    return;
  }

  const map = new google.maps.Map(document.getElementById('centre-map'), {
    zoom: 5.7,
    center: nz,
    streetViewControl: false,
    mapTypeControl: false,
    scrollwheel: false,
    fullscreenControl: false,
    zoomControl: false,
    disableDefaultUI: true,
    styles: [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#d7e8f5',
          },
        ],
      },
      {
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#bdbdbd',
          },
        ],
      },
      {
        featureType: 'administrative.neighborhood',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'road',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dadada',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'transit',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'water',
        stylers: [
          {
            color: '#1378c6',
          },
        ],
      },
    ],

  });

  $(document).on('click', '.js-map-in', () => {
    map.setZoom(map.getZoom() + 1);
  });

  $(document).on('click', '.js-map-out', () => {
    map.setZoom(map.getZoom() - 1);
  });

  if (mobileAndTabletcheck()) {
    initMapMobile(map);
  } else {
    initMapDesktop(map);
  }
}

window.initMap = initMap;


$(window).on('load', () => {
  // init slider
  if ($('.js-slider-gallery').length) {
    const galleryElems = document.querySelectorAll('.js-slider-gallery');

    for (let i = 0, len = galleryElems.length; i < len; i++) {
      const galleryElem = galleryElems[i];

      const flkty = new Flickity(galleryElem, {
        contain: true,
        imagesLoaded: true,
        on: {
          change(index) {
            $(this.element).parents('.js-gallery-caption').find('.js-caption').html($(this.selectedElement).find('img').attr('alt'));
          },
        },
      });
    }
  }
});

module.exports = $;


// -------------------------------------------------------------------------------------------------------
// Notification bar
// -------------------------------------------------------------------------------------------------------

const mediaQueryNotification = window.matchMedia('(min-width: 80em)');

$(document).ready(() => { // once DOM is loaded - init few state in order to bring the notification bar
  if (document.getElementById('alert-banner') != null && document.getElementById('main-content') != null && mediaQueryNotification.matches) {
    const alertBanner = document.getElementById('alert-banner');
    const mainContent = document.getElementById('main-content');
    const alertBannerHeight = alertBanner.clientHeight;

    mainContent.style.transform = `translateY(-${alertBannerHeight}px)`;
  }
});

$(window).on('load', () => {    // once everything is loaded

  const notificationBarUpdateDate = document.getElementById("js-alert-update") ? document.getElementById("js-alert-update").getAttribute("data-update") : null;
  // const currentDate = new Date();
  //
  // if (notificationBarUpdateDate.getTime() < currentDate.getTime()) {
  //
  // }

  if (document.getElementById('alert-banner') != null) {
    const alertBanner = document.getElementById('alert-banner');
    const alertBannerClose = alertBanner.querySelector('.js-close-alert');
    const header = document.querySelector('.js-site-header');
    const mainContent = document.getElementById('main-content');
    const alertBannerHeight = alertBanner.clientHeight; // check height on load

    if (mediaQueryNotification.matches) {
      header.style.transition = 'top 400ms ease';
      header.style.top = `${alertBannerHeight}px`;
      mainContent.style.transition = 'transform 400ms ease';
      mainContent.style.transform = 'translateY(0)';
      mainContent.style.removeProperty('transform');
    }

    function closeBanner() {
      // update style to close banner
      if (mediaQueryNotification.matches) {
        header.style.top = 0;
      }
      mainContent.style.transform = `translateY(-${alertBannerHeight}px)`;
      alertBanner.style.transition = 'transform 400ms ease';
      alertBanner.style.transform = `translateY(-${alertBannerHeight}px)`;


      window._Cookies.set('notification-bar-close-time', notificationBarUpdateDate, { expires: 30 });

      setTimeout(() => {
        // after animation style and banner is removed
        mainContent.style.removeProperty('transition');
        alertBanner.remove();
        mainContent.style.transform = 'translateY(0)';
      }, 400);
    }

    function getAlertBannerResize() { // check on resize
      if (mediaQueryNotification.matches) { // check if media query is changing
        // update banner height if number of line copy is changing
        const alertBannerHeight = alertBanner.clientHeight;
        header.style.top = `${alertBannerHeight}px`;
      } else {
        // if it's under 80em we remove unnecessary style
        header.style.top = 0;
      }
    }

    alertBannerClose.addEventListener('click', closeBanner);
    window.addEventListener('resize', getAlertBannerResize);
  }

  //Update URL for accordion tabs
  $('dt .block-heading--accordion').on('click', function (e) {  
    var currentUrl = window.location.href.split('?')[0];
    var clickedTitle = generateGAParameter($(this).text());
    window.history.pushState(null, null, currentUrl + '?tab=' + clickedTitle);  
  });

  function generateGAParameter(paramValue) {
    // Encode the parameter value to make it URL-safe
    function encodeParameter(value) {
        return encodeURIComponent(value)
            .replace(/%20/g, '-')  // Replace spaces with minus sign
            .replace(/%21/g, '!')  // Keep exclamation marks
            .replace(/%27/g, "'")  // Keep single quotes
            .replace(/%28/g, '(')  // Keep left parentheses
            .replace(/%29/g, ')')  // Keep right parentheses
            .replace(/%2A/g, '*'); // Keep asterisks
    }

    return encodeParameter(paramValue);
}

  // Custom Flickity nav for carousels that render their own controls.
  const navCarousels = document.querySelectorAll('.js-carousel');
  navCarousels.forEach((carousel) => {
    const container = carousel.closest('.mw-1600') || carousel.parentElement;
    const prevBtn = container?.querySelector('.js-flickity-prev');
    const nextBtn = container?.querySelector('.js-flickity-next');
    const currentEl = container?.querySelector('.js-flickity-current');
    const totalEl = container?.querySelector('.js-flickity-total');

    if (!prevBtn || !nextBtn || !currentEl || !totalEl) return;

    let isNavReady = false;
    const shouldCountVisibleSlides = carousel.classList.contains('section--donate-ways__carousel');

    const getVisibleSlideCount = (flkty) => {
      if (!shouldCountVisibleSlides) return 1;

      const cells = flkty.cells || [];
      const availableWidth = flkty.size?.innerWidth || carousel.clientWidth;
      let visibleSlides = 0;
      let visibleWidth = 0;

      for (let index = flkty.selectedIndex; index < cells.length; index += 1) {
        const cell = cells[index];
        const cellWidth = cell?.size?.outerWidth || cell?.element?.offsetWidth || 0;

        if (!cellWidth) continue;
        if (visibleWidth + cellWidth > availableWidth + 1) break;

        visibleWidth += cellWidth;
        visibleSlides += 1;
      }

      return Math.max(1, visibleSlides);
    };

    const updateFlickityNav = (flkty) => {
      if (!flkty) return;

      const totalSlides = shouldCountVisibleSlides ? flkty.cells.length : flkty.slides.length;
      const visibleSlideCount = getVisibleSlideCount(flkty);
      const currentSlide = totalSlides ? Math.min(totalSlides, flkty.selectedIndex + visibleSlideCount) : 0;
      const isFirstSlide = flkty.selectedIndex === 0;
      const isLastSlide = totalSlides <= 1 || currentSlide >= totalSlides;

      totalEl.textContent = totalSlides;
      currentEl.textContent = currentSlide;

      prevBtn.disabled = isFirstSlide;
      nextBtn.disabled = isLastSlide;
      prevBtn.classList.toggle('is-disabled', isFirstSlide);
      nextBtn.classList.toggle('is-disabled', isLastSlide);
      prevBtn.setAttribute('aria-disabled', isFirstSlide);
      nextBtn.setAttribute('aria-disabled', isLastSlide);
    };

    const setupFlickityNav = (flkty) => {
      if (!flkty || isNavReady) return;

      isNavReady = true;
      updateFlickityNav(flkty);

      flkty.on('ready', () => {
        updateFlickityNav(flkty);
      });

      flkty.on('change', () => {
        updateFlickityNav(flkty);
      });

      flkty.on('resize', () => {
        updateFlickityNav(flkty);
      });
    };

    prevBtn.addEventListener('click', () => {
      const flkty = Flickity.data(carousel);
      if (!flkty) return;

      flkty.previous();
      updateFlickityNav(flkty);
    });

    nextBtn.addEventListener('click', () => {
      const flkty = Flickity.data(carousel);
      if (!flkty) return;

      flkty.next();
      updateFlickityNav(flkty);
    });

    const existingFlkty = Flickity.data(carousel);
    if (existingFlkty) {
      setupFlickityNav(existingFlkty);
      return;
    }

    const observer = new MutationObserver(() => {
      const flkty = Flickity.data(carousel);
      if (!flkty) return;

      setupFlickityNav(flkty);
      observer.disconnect();
    });
    observer.observe(carousel, { attributes: true, attributeFilter: ['class'] });

    setTimeout(() => {
      const flkty = Flickity.data(carousel);
      if (!flkty) return;

      setupFlickityNav(flkty);
      observer.disconnect();
    }, 100);
  });

});
